<template>
  <div
    class="video-player-box"
    v-if="src"
    :style="{ width: $pxToVw(width), height: $pxToVw(height) }"
  >
    <div class="video-player-box__inner">
      <div class="video-player-box__poster-box" v-show="!isPlaying">
        <img
          src="../assets/imgs/icon-play-btn.png"
          class="video-player-box__play-btn"
          @click="handlePlayVideo"
        />
        <van-image :src="poster" class="video-player-box__poster" fit="cover" />
      </div>
      <video
        webkit-playsinline
        playsinline
        x5-playsinline
        x-webkit-airplay="allow"
        v-show="isPlaying"
        :src="src"
        controls
        class="video-player video-player-box__comp vjs-custom-skin"
        x5-video-player-type="h5"
        x5-video-orientation="portraint"
        ref="videoPlayer"
        @play="handleOnPlay"
      ></video>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 690,
    },
    height: {
      type: Number,
      default: 400,
    },
    poster: {
      type: String,
      default: "",
    },
    src: {
      type: String,
      default: "",
    },
    videoName: {
      type: String,
      default: "",
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPlaying: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleOnPlay() {
      window.sensors.track("JoinPagePlayVideo", {
        join_video_name: this.videoName,
      });
    },
    handlePlayVideo() {
      this.isPlaying = true;
      setTimeout(() => {
        this.$refs.videoPlayer.play();
      }, 100);
    },
  },
};
</script>
<style lang="scss"  >
  .video-player-box {
    width: 690px;
    height: 400px;
    padding: 12px;
    overflow: hidden;
    margin: auto;

    background-color: #ffffff;
    box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.08);
    border-radius: 33px;

    &__poster-box {
      width: 100%;
      height: 100%;
      position: relative;
    }
    &__poster {
      width: 100%;
      height: 100%;
      border-radius: 28px;
      overflow: hidden;
    }
    &__play-btn {
      width: 96px;
      height: 96px;
      position: absolute;
      z-index: 9;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }

    &__inner {
      width: 100%;
      height: 100%;
      margin: auto;
      border-radius: 28px;
      overflow: hidden;
    }

    .video-js,
    &__comp {
      height: 100%;
      width: 100%;
      border-radius: 28px;
      overflow: hidden;
      position: relative;
      background-color: white !important;
    }
    .vjs-tech {
      object-fit: cover;
      background-color: white !important;
      overflow: hidden;
    }
    .vjs-poster {
      background-size: cover;
      background-color: white !important;
    }
    .video-js .vjs-mute-control {
      padding-right: 0 !important;
    }
    .vjs-custom-skin .video-js .vjs-big-play-button {
      width: 96px !important;
      height: 96px !important;
      line-height: 96px !important;
      border-radius: 50% !important;
      left: 0 !important;
      top: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      margin: auto !important;
    }
    .video-js:hover .vjs-big-play-button,
    .vjs-custom-skin > .video-js .vjs-big-play-button:focus,
    .vjs-custom-skin > .video-js .vjs-big-play-button:active {
      background-color: rgba(0, 0, 0, 0.45) !important;
    }
    .vjs-control-bar {
      //   opacity: 1 !important;
      width: 100%;
      background-color: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.8) 100%
      ) !important;
    }
    // .vjs-custom-skin > .video-js .vjs-play-progress:before {
    //   top: 0.06em;
    // }

    .vjs-custom-skin > .video-js .vjs-control-bar .vjs-time-control {
      margin-left: -8px;
    }

    .vjs-custom-skin > .video-js .vjs-play-progress,
    .vjs-custom-skin > .video-js .vjs-volume-level {
      background-color: white !important;
    }
    .vjs-modal-dialog-content,
    .vjs-error .vjs-error-display:before {
      display: none;
    }
  }
</style>
